import React from "react";

export default function OemRateModel({ show, currentValue, onClose, onBoardChange, onUpdate }) {
     
    return (
      <div
        className={`modal fade ${show ? "show" : "hide"}`}
        style={{ display: show ? "block" : "none" }}
        id="modal-lg"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Rate based on OEM</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true" onClick={() => onClose()}>
                  ×
                </span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-sm-6">
                <div className="form-group">
                  <label>Front Board</label>
                  <input
                    type="text"
                    name="text"
                    className="form-control"
                    id="frontboard"
                    onChange={(e) => onBoardChange(e.target.value, 'front')}
                    placeholder="Front Board"
                    defaultValue={currentValue.fboard ?? ''}
                  />
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group">
                  <label>Rear Board</label>
                  <input
                    type="text"
                    name="text"
                    className="form-control"
                    id="backboard"
                    onChange={(e) => onBoardChange(e.target.value, 'rear')}
                    placeholder="Back Board"
                    defaultValue={currentValue.rboard ?? ''}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-between">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
                onClick={() => onClose()}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                // onClick={() => (currentValueFlag ? onUpdate() : onSave())}
                onClick={() => (onUpdate())}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    );
}
